import type { FontSubsetRequest } from '@/framework/services/font';
import type { TextRenderInput } from '../types';
import { createListMarkerTexts } from './list';

/**
 * 汇总正文与列表 marker 使用的字体子集请求。
 *
 * 正文始终先写入，列表 marker 文案随后追加到相同字体族，保持既有字符拼接顺序与字体请求判定。
 *
 * @param input - 使用宿主声明字体族的原始 Text Render Input。
 * @returns 按首次出现的字体族顺序汇总的子集请求。
 */
export const createFontRequests = (input: TextRenderInput): FontSubsetRequest[] => {
    const requests = new Map<string, string>();
    const bodyRequests =
        input.spans.length > 0
            ? input.spans.map((span) => ({ fontFamily: span.fontFamily, chars: span.text }))
            : [{ fontFamily: input.fontFamily, chars: input.text }];

    bodyRequests.forEach(({ fontFamily, chars }) => {
        if (fontFamily && chars) requests.set(fontFamily, `${requests.get(fontFamily) ?? ''}${chars}`);
    });

    const marker = input.listMarker;
    const markerFontFamily =
        marker?.kind === 'character' ? input.fontFamily : marker?.kind === 'svg' ? marker.numberFontFamily : undefined;
    const markerChars = createListMarkerTexts(input).join('');
    if (markerFontFamily && markerChars) {
        requests.set(markerFontFamily, `${requests.get(markerFontFamily) ?? ''}${markerChars}`);
    }

    return Array.from(requests, ([fontFamily, chars]) => ({ fontFamily, chars }));
};
